module.exports = __webpack_public_path__ + "d2099a58c1996981ee2f551d4843ddae.svg";